'use client';

import {
    Button,
    ButtonList,
    ButtonVariant,
    Modal,
    ModalBody,
    ModalFooter,
    Spacer,
    SpacerSize,
    Text,
    TextLevels,
    TypographyBold,
} from '@bytel/trilogy-react';

import { InlinePrice } from '@components/inline-price';

type InflationModalProps = {
    active: boolean;
    onClose: () => void;
};
export default function InflationModal({ active, onClose }: Readonly<InflationModalProps>) {
    return (
        <Modal active={active} onClose={onClose} title='On vous dit tout sur cette évolution de prix'>
            <ModalBody>
                <Text level={TextLevels.ONE} typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}>
                    Comment ce prix va-t-il être révisé ?
                </Text>
                <Text>
                    Le prix de ce forfait sera revu en fonction de l’évolution annuelle de l’indice «&nbsp;coût horaire
                    du travail révisé – Tous salariés du Secteur d’activité Information Communication&nbsp;» publié par
                    l’Insee.
                </Text>
                <Text>Si elle est à la hausse, cette révision ne pourra pas excéder 1€/mois.</Text>
                <Text>
                    Par exemple : en juin 2024, l’indice a varié de 2,7% sur l’année. Ce qui équivaut à une augmentation
                    de <InlinePrice amount={0.27} period='mois' typo={[]} /> pour un forfait à{' '}
                    <InlinePrice amount={9.99} period='mois' typo={[]} />
                </Text>
                <Spacer size={SpacerSize.FOUR} />
                <Text level={TextLevels.ONE} typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}>
                    Quand ce prix va-t-il être révisé ?
                </Text>
                <Text>
                    Rassurez-vous, le prix de votre forfait ne changera pas dans les 15 premiers mois suivant votre
                    souscription. Ce prix sera ensuite revu une fois par an.
                </Text>
                <Text>Bien sûr, on vous informera un mois avant l’application de ce nouveau tarif.</Text>
            </ModalBody>
            <ModalFooter>
                <ButtonList>
                    <Button variant={ButtonVariant.CONVERSION} onClick={onClose}>
                        Fermer
                    </Button>
                </ButtonList>
            </ModalFooter>
        </Modal>
    );
}
